<template>
  <qc-container title="商品审核">
    <page-request ref="table" url="/api/mgr/shop/business/goods/list" :table-header="tableHeader" :expend="expend" :prop="{goodsType:0}" :op-width="200">

      <template #op="scope">
        <b-button @click="doDetail(scope.row)">{{scope.row.applyStatus===0?"审核":"查看"}}</b-button>
      </template>
    </page-request>
  </qc-container>
</template>

<script>

import QcContainer from "@/components/el/layout/qc-container.vue";
import BButton from "@/components/el/b-button.vue";
import TButton from "@/components/el/t-button.vue";
import PageRequest from "@/components/base/page-request.vue";

export default {
  name: "audit",
  components: {PageRequest, TButton, BButton, QcContainer},
  data() {
    return {
      tableHeader: [
        {type: "selection", label: ""},
        {type: "goods", label: "商品",minWidth:300},
        {label: "价格",renderDraw:row=>{
            let content = "";
            if(row.storeGoodsType===1 ){
              content = "租赁价格:￥"+row.marketPrice+"元";
            }else if(row.storeGoodsType===2){
              content = "出售价格:￥"+row.salesPrice+"元<br/>"+"租赁价格:￥"+row.marketPrice+"元"
            }else{
              content = "出售价格:￥"+row.salesPrice+"元";
            }
            return content + (row.isAttribute?"起":"");
          },width:220},
        {prop: "inventory", label: "库存",width:100,renderDraw:row=>{
            return row.inventory + (row.marketInventory||0);
          }},
        {label: "状态",renderDraw:row=>{return row.applyStatus==0?"待审核":row.applyStatus==1?"通过":"驳回";},width: 100},
        {prop: "errorMsg", label: "意见",width:160},
        {prop: "updateTime", label: "更新时间",width:160},
        {prop: "createTime", label: "创建时间",width:160},
      ],
      expend: [
        {label: "商品名称", prop: "name"},
        {label: "商品ID", prop: "codes"}
      ],
    }
  },
  watch:{
    $route(val){
      if(val.path === '/index/shop/audit'){
        this.pageReloadData();
      }
    }
  },
  mixins: [tableBase],
  methods: {
    doDetail(row){
      this.toRouter("/index/shop/goods/detail",row?{id:row.id,type:this.type}:{})
    }

  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
